import { render, staticRenderFns } from "./dialogAccess.vue?vue&type=template&id=35f94e5f&scoped=true&lang=pug&"
import script from "./dialogAccess.vue?vue&type=script&lang=js&"
export * from "./dialogAccess.vue?vue&type=script&lang=js&"
import style0 from "./dialogAccess.vue?vue&type=style&index=0&id=35f94e5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f94e5f",
  null
  
)

export default component.exports